import { takeEvery, fork, put, all, call } from "redux-saga/effects";

import {
  apiError,
  getBrands,
  brandListSuccessful,
  brandAddSuccessful,
  isModelVisible,
} from "./brandSlice";

// AUTH related methods
import {
  postAdd,
  getParamsList,
  postEdit,
  postDelete,
} from "../../../helpers/Helper";
import { Modal } from "antd";
import {
  RiCheckboxCircleLine,
  RiAlertLine,
  RiInformationLine,
} from "react-icons/ri";
import brandData from "./brandData.json"

function* getBrand({ payload }) {
  var data = payload;
  var params = {};

  for (const k in data) {
    if (Object.hasOwnProperty.call(data, k)) {
      if (k === "currentSort" || k === "sortOrder") {
        params.ordering = data.sortOrder + data.currentSort;
      } else {
        if (data[k] != "" && k != null && k != "no_of_pages") {
          params[k] = data[k];
        }
      }
    }
  }
  try {
    // const response = yield call(getParamsList, "/masters/brands/", params);
    const BrandData = brandData
    yield put(brandListSuccessful({ BrandData }));
  } catch (error) {
    yield put(apiError(error));
  }
}
function* AddBrand({ payload }) {
  try {
    if (payload.id == 0) {
      const response = yield call(postAdd, "/masters/brands/", payload);
      if (response.status === 201) {
        Modal.success({
          icon: (
            <span className="remix-icon">
              <RiCheckboxCircleLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">success</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Your Brand Add Successfully.!
              </p>
            </div>
          ),
        });
        yield put(getBrands({ page: 1, search: "", page_size: 10 }));
        yield put(isModelVisible(false));
      } else {
        Modal.error({
          icon: (
            <span className="remix-icon">
              <RiAlertLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Sorry! Unable to added Brand. Please try again!
              </p>
            </div>
          ),
        });
      }
      yield put(brandAddSuccessful(null));
    } else {
      const response = yield call(
        postEdit,
        "/masters/brands/" + payload.id,
        payload
      );
      if (response.status === 200) {
        Modal.success({
          icon: (
            <span className="remix-icon">
              <RiCheckboxCircleLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">success</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Your Brand Edited Successfully.!
              </p>
            </div>
          ),
        });
        yield put(getBrands({ page: 1, search: "", page_size: 10 }));
        yield put(isModelVisible(false));
      } else {
        Modal.error({
          icon: (
            <span className="remix-icon">
              <RiAlertLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Sorry! Unable to edit Brand. Please try again!
              </p>
            </div>
          ),
        });
      }
      yield put(brandAddSuccessful(null));
    }
  } catch (error) {
    Modal.error({
      icon: (
        <span className="remix-icon">
          <RiAlertLine />
        </span>
      ),

      title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
      content: (
        <div>
          <p className="hp-p1-body hp-text-color-black-80">
            Sorry! Getting from server side issue!
          </p>
        </div>
      ),
    });
    yield put(apiError(error));
  }
}

function* DeleteBrand({ payload }) {
  var countryID = payload;
  try {
    const response = yield call(postDelete, "/masters/brands/" + countryID);
    if (response.status === 204) {
      Modal.success({
        icon: (
          <span className="remix-icon">
            <RiCheckboxCircleLine />
          </span>
        ),
        title: <h5 className="hp-mb-0 hp-font-weight-500">success</h5>,
        content: (
          <div>
            <p className="hp-p1-body hp-text-color-black-80">
              Your Brand has been deleted!
            </p>
          </div>
        ),
      });
      yield put(getBrands({ page: 1, search: "", page_size: 10 }));
    } else {
      Modal.error({
        icon: (
          <span className="remix-icon">
            <RiAlertLine />
          </span>
        ),
        title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
        content: (
          <div>
            <p className="hp-p1-body hp-text-color-black-80">
              Sorry! Your Brand has been not deleted!
            </p>
          </div>
        ),
      });
    }
  } catch (error) {
    Modal.error({
      icon: (
        <span className="remix-icon">
          <RiAlertLine />
        </span>
      ),

      title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
      content: (
        <div>
          <p className="hp-p1-body hp-text-color-black-80">
            Sorry! Getting from server side issue!
          </p>
        </div>
      ),
    });

    yield put(apiError(error));
  }
}

export function* watchgetBrands() {
  yield takeEvery("brand/getBrands", getBrand);
}
export function* watchBrandAdd() {
  yield takeEvery("brand/brandAdd", AddBrand);
}

export function* watchBrandDelete() {
  yield takeEvery("brand/brandDelete", DeleteBrand);
}

function* BrandSaga() {
  yield all([
    fork(watchgetBrands),
    fork(watchBrandAdd),
    fork(watchBrandDelete),
  ]);
}

export default BrandSaga;
